// @flow
import * as React from 'react';
import makeAsyncScriptLoader from 'react-async-script';

const googleAPIURL = `https://maps.googleapis.com/maps/api/js?client=gme-coxenterprises&channel=xtime&libraries=places`;

type Props = {};

export default function<C: React.ComponentType<Props>>(
  Component: C
): React.Element<C> {
  return makeAsyncScriptLoader(googleAPIURL, { globalName: 'google' })(
    Component
  );
}



// WEBPACK FOOTER //
// ./src/components/api/components/WithGooglePlaces/WithGooglePlaces.js